// 运营管理
export default [
    {
        path: '/operationsManaments/abnormal',
        name: 'abnormal',
        meta: {
            title: '投递异常分析'
        },
        component: () => import('@/views/operationsManaments/abnormal/index.vue')
    },
    {
        path: '/operationsManaments/pointOperations/list',
        name: 'configRule',
        meta: {
            title: '点位运营数据'
        },
        component: () => import('@/views/operationsManaments/pointOperations/list.vue')
    },
    {
        path: '/operationsManaments/pointOperations/details',
        name: 'pointOperationsDetails',
        meta: {
          title: '点位详情'
        },
        component: () => import('@/views/operationsManaments/pointOperations/detail.vue')
      },
    {
        path: '/operationsManaments/supervise',
        name: 'supervise',
        meta: {
            title: '积分规则配置页面'
        },
        component: () => import('@/views/operationsManaments/supervise/index.vue')
    },

]
